export default "__VITE_ASSET__Cfmt1s_$__"